export const LEFT_MENU_WIDTH = 224;
import * as Colors from 'material-ui/styles/colors';

const h2 = {
  fontSize: 20,
  color: Colors.grey400,
  fontWeight: 500,
};
const h3 = {
  fontSize: 30,
  color: Colors.grey400,
  fontWeight: 500,
};
export default {
  h3: {
    fontSize: 30,
    color: Colors.grey400,
    fontWeight: 500,
  },
  dialogBody: {
    padding: 0,
    fontSize: 16,
    color: Colors.grey600,
  },
  button: {
    width: 230,
    position: 'relative',
  },
  dialogContent: {
    height: 530,
    maxHeight: 530,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 500,
    width: '100%',
    position: 'relative',
    justifyContent: 'space-between',
    paddingTop: 20,
    paddingBottom: 20,
  },
  pageContentContainer: {
    marginLeft: 110,
    marginRight: 'auto',
    paddingRight: 50,
    maxWidth: 950,
    marginTop: 65,
  },
  h1: {
    fontSize: 24,
    marginBottom: 20,
  },
  container: {
    display: 'flex',
    paddingLeft: 20,
    margin: 20,
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    minHeight: 150,
    maxWidth: 200,
  },
  h2: h2,
  h2b: {
    ...h2,
    color: Colors.grey700,
  },
  h3b: {
    ...h3,
    color: Colors.grey700,
  },
  inputField: {
    width: '100%',
  },
  card: {
    padding: 20,
    marginTop: 20,
    marginBottom: 30,
  },
};
